import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './DemoHeader.css';

const DemoHeader = ({ title, image, selectedCommunity, backTo }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBackClick = () => {
    if (backTo) {
      navigate(backTo);
      return;
    }

    // Check if we're in community mode and have community data
    const urlParams = new URLSearchParams(location.search);
    const communityId = urlParams.get('community');
    
    if (communityId && selectedCommunity?.databaseRef) {
      // Navigate to the CommunityHome page using databaseRef
      navigate(`/${selectedCommunity.databaseRef}`);
    } else {
      // Navigate to home page for general demo
      navigate('/');
    }
  };

  return (
    <div className="demo-header-container">   
      <div className="demo-header-back-btn" onClick={handleBackClick}>←</div>
      <div className="demo-chat-info-container">
        <img 
          className="demo-conversation-img demo-clickable-icon" 
          src={image || 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiM2NjdlZWEiLz4KPHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4PSI4IiB5PSI4Ij4KPHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDJDMTMuMSAyIDE0IDIuOSAxNCA0VjZIMjBDMjEuMSA2IDIyIDYuOSAyMiA4VjE0SDIwVjhIMTRWMTBIMTJWOEg2VjE0SDhWMTZINkMzLjkgMTYgMiAxNC4xIDIgMTJWOEMyIDYuOSAzLjkgNiA2IDZIMTJWNEMxMiAyLjkgMTIuOSAyIDEyIDJaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4KPC9zdmc+Cjwvc3ZnPgo='} 
          alt="" 
          onClick={handleBackClick}
          title="Back to community home"
        />
        <div className="demo-chat-title">
          Chat with {title || 'Platform Demo Chat'}
        </div>
      </div>
    </div>
  );  
};

export default DemoHeader;